import { render, staticRenderFns } from "./kkform.vue?vue&type=template&id=50180b69&scoped=true&"
import script from "./kkform.vue?vue&type=script&lang=js&"
export * from "./kkform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50180b69",
  null
  
)

export default component.exports